import { render, staticRenderFns } from "./lrUpload.vue?vue&type=template&id=22bc19f8"
import script from "./lrUpload.vue?vue&type=script&lang=js"
export * from "./lrUpload.vue?vue&type=script&lang=js"
import style0 from "./lrUpload.vue?vue&type=style&index=0&id=22bc19f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports